<template>
  <div class="home-page">
    <index-banner ref="indexBanner" />
    <index-chats ref="indexChats" />
    <bottom-fixed @goToOnsaleProduct="goToOnsaleProduct" />
    <bottom-products ref="indexProducts" />
    <index-overlay />
  </div>
</template>

<script>
import IndexBanner from '@/components/index-banner'
import IndexChats from '@/components/index-chats'
import BottomFixed from '@/components/bottom-fixed'
import BottomProducts from '@/components/bottom-products'
import IndexOverlay from '@/components/index-overlay/index'
import { getUrlKeys } from '@/utils/index'
import TIM from 'tim-js-sdk'

export default {
  components: { IndexBanner, IndexChats, BottomFixed, BottomProducts, IndexOverlay },

  created () {
    this.initRoom()
  },

  methods: {
    initRoom () {
      // 判断是否有 roomid
      const idArr = this.$route.params.id.split('-')
      if (idArr.length === 0) {
        localStorage.removeItem('v2-token')
        return this.toast.fail('获取房间失败')
      }

      const roomId = idArr[0]
      const shareId = idArr[1]

      // 获取直播间详情
      this.request({
        url: '/liveRoom/detail',
        data: { id: roomId, expandId: shareId || '' }
      }).then(roomRes => {
        this.$store.dispatch('initRoom', roomRes.result)

        // this.$refs.indexLive.registerVideo(roomRes.result)
        // this.$store.dispatch('initVideo')

        // 首次进入直播间弹二维码
        if (this.area.initPopupCode) {
          this.$store.dispatch('initPopupCode')
        }

        // 初始化标题
        window.document.title = roomRes.result.name

        // 获取历史聊天记录
        this.request({ url: '/liveRoom/auth/historyMsg', data: { groupId: roomRes.result.imChatroom, pageSize: 80 }}).then(historyRes => {
          this.$refs.indexChats.setHistoryChatList(historyRes.result.rows)
        })

        // 获取商品列表
        this.$store.dispatch('getProducts', roomId)

        // 初始化表单用户
        this.$refs.indexProducts.initForm(roomRes.result.memberNewestInfo)

        // 设置置顶消息
        if (roomRes.result.topInfo) this.$store.commit('setTopMessage', JSON.parse(roomRes.result.topInfo))

        // 初始化 im
        if (!this.$store.state.tim.tim) {
          this.$store.dispatch('initTim', { chatroom: roomRes.result.imChatroom })
        }
      })
    },

    goToOnsaleProduct () {
      this.$refs.indexProducts.goToOnsaleProduct() 
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  height: 100vh;
  width: 100vw;
  max-width: 100vw;
  // background-color: #320372;
  background-color: #8308B7;
}
</style>